import { useEffect, useState } from "react";
import { GlobalRequest } from "../../../common/services/request";

interface FilterOption {
  id: string | number;
  name: string;
}

interface FiltersProps {
  uri: string;
  filterKey?: string;
  params: any;
  onChange: (params: any) => void;
  initialParams?: any;
  allLabel?: string;
  getParams?: (
    option: FilterOption,
    params: any
  ) => Record<string, any>;
}

export const Filters = ({
  uri,
  filterKey,
  params,
  onChange,
  initialParams,
  allLabel = "Tous",
  getParams,
}: FiltersProps) => {
  const [options, setOptions] = useState<FilterOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedValue, setSelectedValue] = useState<
    string | number | undefined
  >(filterKey ? params?.[filterKey] : undefined);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        setIsLoading(true);

        const res = await GlobalRequest.get(uri);

        if (res?.data?.member) {
          setOptions(res.data.member);
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des filtres :",
          error
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, [uri]);

  // Synchronise le bouton actif avec les params externes
  useEffect(() => {
    filterKey && setSelectedValue(params?.[filterKey]);
  }, [params, filterKey]);

  const handleFilterChange = (option?: FilterOption) => {
    // Tous
    if (!option) {
      setSelectedValue(undefined);
  
      onChange(initialParams ?? {});
  
      return;
    }
  
    // Option sélectionnée
    setSelectedValue(option.id);
  
    const customParams = getParams
      ? getParams(option, params)
      : {};
  
    onChange({
      ...params,
      page: 1,
      ...(filterKey ? { [filterKey]: option.id } : {}),
      ...customParams,
    });
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-3 mt-3 ms-3 me-3" style={{overflow: "auto"}}>
      {/* TOUS */}
      <button
        type="button"
        className={`btn ${
          selectedValue === undefined
            ? "btn-primary"
            : "btn-outline-primary"
        }`}
        // style={{ flex: 1, width: "90%" }}
        style={{
          minWidth: "250px",
          maxWidth: "100%",
          height: "40px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "14px",
        }}
        onClick={() => handleFilterChange()}
      >
        {allLabel}
      </button>

      {/* OPTIONS */}
      {options.map((option) => {
        const isActive = selectedValue === option.id;

        return (
          <button
            key={option.id}
            type="button"
            className={`btn ${
              isActive
                ? "btn-primary"
                : "btn-outline-primary"
            }`}
            // style={{ flex: 1, width: "90%" }}
            style={{
              minWidth: "250px",
              maxWidth: "100%",
              height: "40px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "14px",
            }}
            onClick={() => handleFilterChange(option)}
          >
            {option.name}
          </button>
        );
      })}
    </div>
  );
};